module.exports = __webpack_public_path__ + "static/media/star-into.a65e56f0.png";